import * as yup from 'yup';


const cronRegex = /^(\*|(?:[0-9]|(?:[1-5][0-9]))(?:(?:\-[0-9]|\-(?:[1-5][0-9]))?|(?:\,(?:[0-9]|(?:[1-5][0-9])))*)) (\*|(?:[0-9]|1[0-9]|2[0-3])(?:(?:\-(?:[0-9]|1[0-9]|2[0-3]))?|(?:\,(?:[0-9]|1[0-9]|2[0-3]))*)) (\*|(?:[1-9]|(?:[12][0-9])|3[01])(?:(?:\-(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:\,(?:[1-9]|(?:[12][0-9])|3[01]))*)) (\*|(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:\-(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?|(?:\,(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))*)) (\*|(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT)(?:(?:\-(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))?|(?:\,(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))*))$/;

export const QuoteAutomationValidationSchema = (total) => {
  return yup.object().shape({
    quoteName: yup.string().required('Field is required'),
    startAfterDays: yup.number().nullable(),
    customStartAfterDays: yup
      .number()
      .when('startAfterDays', {
        is: 0,
        then: yup.number()
          .required('Custom Start Date Range (days) is required')
          .typeError('Field is required')
          .integer('Only integer numbers allowed')
          .min(0, 'Value cannot go lower than 0'),
        otherwise: yup.number().nullable(),
      }),
    expireAfterDays: yup.number().nullable().required('Field is required'),
    customExpireAfterDays: yup
      .number()
      .when('expireAfterDays', {
        is: 0,
        then: yup.number()
          .required('Custom Expiration Date Range (days) is required')
          .typeError('Field is required')
          .integer('Only integer numbers allowed')
          .min(0, 'Value cannot go lower than 0'),
        otherwise: yup.number().nullable(),
      }),
    mustUsedBeforeDays: yup.number().nullable(),
    customMustUsedBeforeDays: yup
      .number()
      .when('mustUsedBeforeDays', {
        is: 0,
        then: yup.number()
          .required('Custom Expiration Date Range (days) is required')
          .typeError('Field is required')
          .integer('Only integer numbers allowed')
          .min(0, 'Value cannot go lower than 0'),
        otherwise: yup.number().nullable(),
      }),
    quoteNotes: yup.string(),
    quoteDiscount: yup.object().shape({
      price_type: yup.string(),
      price: yup
        .number()
        .typeError('Allowed only numerical symbols')
        .positive('Value must be positive')
        .min(0, 'Price should be a positive number')
        .test(
          'price',
          'The unit price can\'t be lower than discount',
          function (value) {
            const { price_type } = this.parent;
            const formattedFixedPrice = total?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

            if (price_type === 'percent') {
              if (isNaN(value) || value < 0 || value > 100) {
                return this.createError({ message: 'Discount must be between 0 and 100' });
              }
            } else if (isNaN(value) || value < 0 || value > total) {
              return this.createError({
                message: `Discount must be between 0 and $${formattedFixedPrice}`,
              });
            }

            return true;
          }
        )
        .required('Field is required'),
    }),
    period: yup.string().required('Field is required'),
    customCronExpression: yup
      .string()
      .when('period', {
        is: 'custom',
        then: yup
          .string()
          .required('Field is required')
          .matches(cronRegex, 'Invalid cron expression format'),
        otherwise: yup.string().nullable(),
      }),
    runImmediately: yup.boolean(),
    akwaRuleId: yup.string().required('Field is required'),
  }, []);
};
